import { useDispatch, useSelector } from "react-redux";

import { Avatar, Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { selectWorkspace } from "app/store/modules/actions/workspaces.actions";

function statusLabel(workspace) {
  if (workspace.disabled) return " — membership disabled";
  if (workspace.workspaceDisabled) return " — workspace suspended";
  return "";
}

function workspaceInitials(name) {
  const initials = String(name || "Workspace")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("");

  return initials.toUpperCase();
}

function WorkspaceLabel({ workspace }) {
  return (
    <Box className="d-flex align-items-center min-w-0">
      <Avatar
        alt={`${workspace.name} logo`}
        src={workspace.companyLogo || undefined}
        className="mr-2"
        sx={{ width: 26, height: 26, fontSize: 11 }}
      >
        {workspaceInitials(workspace.name)}
      </Avatar>
      <Box component="span" className="text-truncate">
        {workspace.name}
        {statusLabel(workspace)}
      </Box>
    </Box>
  );
}

export default function WorkspaceSwitcher() {
  const dispatch = useDispatch();
  const { available, activeWorkspaceId, bootstrapStatus } = useSelector(
    (state) => state.workspaces
  );
  const activeWorkspace = available.find(
    (workspace) => workspace.workspaceId === activeWorkspaceId
  );

  if (bootstrapStatus === "idle") return null;

  return (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel id="workspace-switcher">Workspace</InputLabel>
      <Select
        label="Workspace"
        labelId="workspace-switcher"
        value={activeWorkspaceId || ""}
        onChange={(event) => dispatch(selectWorkspace(event.target.value))}
        disabled={bootstrapStatus !== "ready" || available.length === 0}
        inputProps={{ "aria-label": "Select workspace" }}
        renderValue={() => (activeWorkspace ? <WorkspaceLabel workspace={activeWorkspace} /> : "")}
      >
        {available.map((workspace) => (
          <MenuItem
            key={workspace.workspaceId}
            value={workspace.workspaceId}
            disabled={workspace.disabled || workspace.workspaceDisabled}
          >
            <WorkspaceLabel workspace={workspace} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
